import { CartLinesUpdateEvent } from "@shopify/events";
document.addEventListener("click", async (event) => {
  const button = event.target instanceof Element ? event.target.closest("[data-nappi-bundle-add]") : null;
  if (!button || button.getAttribute("aria-busy") === "true") return;
  event.preventDefault();
  const id = Number(button.dataset.variant);
  const quantity = Number(button.dataset.qty);
  if (!Number.isInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity <= 0) return;
  const label = button.textContent;
  button.setAttribute("aria-busy", "true");
  button.disabled = true;
  if (button.dataset.labelAdding) button.textContent = button.dataset.labelAdding;
  const sections = [
    ...new Set(
      [...document.querySelectorAll("cart-items-component")].map((el) => el instanceof HTMLElement ? el.dataset.sectionId : "").filter(Boolean)
    )
  ];
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: "add",
      context: "cart",
      lines: [{ merchandiseId: String(id), quantity }],
      promise: deferred.promise
    })
  );
  const restore = () => {
    button.removeAttribute("aria-busy");
    button.disabled = false;
    button.textContent = label;
  };
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id, quantity }], sections: sections.join(",") })
    });
    let data = await res.json();
    if (!res.ok || data?.status) throw new Error(data?.description || data?.message || "add failed");
    const code = button.dataset.code;
    if (code) {
      const upd = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: code, sections: sections.join(",") })
      });
      if (upd.ok) data = await upd.json();
    }
    const cartRes = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    const cart = await cartRes.json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: "nappi-bundle-nudge",
        itemCount: quantity,
        sections: data?.sections,
        didError: false
      }
    });
  } catch (error) {
    deferred.reject(error);
  } finally {
    restore();
  }
});
